import { render, staticRenderFns } from "./FaceCheck.vue?vue&type=template&id=f79d17fc&scoped=true&"
import script from "./FaceCheck.vue?vue&type=script&lang=js&"
export * from "./FaceCheck.vue?vue&type=script&lang=js&"
import style0 from "./FaceCheck.vue?vue&type=style&index=0&id=f79d17fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79d17fc",
  null
  
)

export default component.exports